import { render } from "./CollectionList.vue?vue&type=template&id=b48ea540"
import script from "./CollectionList.vue?vue&type=script&lang=js"
export * from "./CollectionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__